import * as React from "react";
import styled from "styled-components";
import { Flex } from "../../designSystem/compositeComponents/FlexHelpers";

type SingleColumnLayoutProps = React.PropsWithChildren<{
    narrow?: boolean
}>;

export function SingleColumnLayout(props: SingleColumnLayoutProps): JSX.Element
{
    return (
        <ContentWrapper narrow={props.narrow}>
            <Flex flexDirection="column" gap={32}>
                {props.children}
            </Flex>
        </ContentWrapper>
    )
}

const ContentWrapper = styled.div<{narrow?: boolean}>`
    width:90%;
    max-width: ${props => props.narrow ? '1020px' : '90%'};
    margin: 0 auto;
    padding:0px;
`;